import { api } from '../../apiAxios';
import { urlHttpGov } from '../../urls';
import { getToken } from '../../LStorage/token';

class InstitucionalService {
    private baseURL: string = `${urlHttpGov}`;

    async getGestorEntidade(idEntidade: string | number, signal: AbortSignal): Promise<any> {

        let { data } = await api.get(`${this.baseURL}${process.env.REACT_APP_BACKEND === 'local' ? '' :'/gestor'}/entity/${idEntidade}`,
            {
                headers: {
                    Authorization: "Bearer " + getToken(),
                },
                signal
            });

        return data;
    }

    async setGestorEntidade(
        idEntidade: string | number,
        obj: any,
        signal: AbortSignal
    ): Promise<any> {

        let { data } = await api.put(`${this.baseURL}${process.env.REACT_APP_BACKEND === 'local' ? '' :'/gestor'}/entity/${idEntidade}`,
            obj,
            {
                headers: {
                    Authorization: "Bearer " + getToken(),
                    "Content-Type": "multipart/form-data",
                },
                signal
            });

        return data;
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new InstitucionalService();
